exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-item-daterange[data-v-2a4755ea] .el-range-separator{width:20px}\n", ""]);

// exports
